module.exports = __webpack_public_path__ + "static/media/subscribe-bg.fec85562.jpg";